import React from "react";
import {Input} from "reactstrap";
import {useTranslation} from "react-i18next";
import ModalAddVariable from "./ModalAddVariable";

const TextareaWidget = (
  {
    id,
    value,
    placeholder,
    onChange,
    required,
    disabled,
    readonly
  }
) => {
    const {t} = useTranslation();

    const change = (e) => {
        let value = e.target.value;
        onChange(value);
    }

    return <>
        <Input
          type='textarea'
          className='mb-2'
          value={value}
          placeholder={t(placeholder)}
          onChange={change}
          required={required}
          disabled={disabled}
          rows={4}
          id={id}
          readOnly={readonly}
        />
        <ModalAddVariable text={value} change={change}/>
    </>
}

export default TextareaWidget;